<template>

  <div class="column is-3" v-if="showBook != null && showBook">
      <!-- <pre>{{showBook != null}}</pre>
      <pre>{{showBook}}</pre> -->
      <div :class="isMinimal ? '' : 'card'" style="margin-bottom:40px">
          <div >
              <a :href="bookObj.amazon_url + '?tag=bikesleepbike-20'" target="_blank"  rel="nofollow" >
                <figure class="image is-2by3-desktop" v-if="bookObj.amazon_image" :style="isMinimal ? 'background-color:inherit' : 'background-color:#e9e9e9'">
                    <img :src="bookObj.amazon_image" class="book-cover" style="max-width:200px; max-height:300px; height:auto; margin-left:auto; margin-right:auto">
                </figure>
            </a>
             
          </div>
          <div>
           

            <div v-if="!isMinimal" class="card-content has-text-left" style="padding:15px">
                <a class="title is-size-6 is-size-6-mobile" v-if="bookObj.title"
                    :href="bookObj.amazon_url + '?tag=bikesleepbike-20'" target="_blank"  rel="nofollow" 
                    >{{bookObj.title}}</a>
                <p v-if="bookObj.author" class='is-size-7'>By {{bookObj.author}}<span v-if="bookObj.year"> - {{bookObj.year}}</span></p>

                

               
                <p v-if="bookObj.routes" class="small-label" style="margin-top:15px">Route</p>
                <p v-if="bookObj.routes" class="is-size-7">
                    <span
                        v-for="(route, idx) in bookObj.routes.concat().sort()"
                        v-bind:key = route
                        >
                        <a :href="'/routes/' + route"><span>{{route}}</span></a><span v-if="idx != bookObj.routes.length-1">, </span>
                    </span>
                </p>

                <p v-if="bookObj.continents" class="small-label" style="margin-top:15px">Continent</p>
                <p v-if="bookObj.continents" class="is-size-7">
                    <!-- <pre>{{bookObj.continents}}</pre> -->
                    <a
                        class="is-size-7" 
                        v-for="(continent, idx) in bookObj.continents"
                        v-bind:key = continent
                        :href="'/continents/' + continent"
                        >
                        {{continent}}<span v-if="idx != bookObj.continents.length - 1">,</span>
                    </a>
                    <!-- <span >
                        <a :href="'/continents/' + bookObj.continents">{{bookObj.continents.join(", ")}}</a>
                    </span> -->
                </p>

                
              

                <span v-if="bookObj.ridertags && bookObj.ridertags.length > 0" class="small-label" style="margin-top:15px">Rider tags: </span> 
               <span v-if="bookObj.ridertags && bookObj.ridertags.length > 0">
                    <a
                        class="is-size-7" 
                        v-for="(ridertag, idx) in bookObj.ridertags.concat().sort()"
                        v-bind:key = ridertag
                        :href="'/ridertags/' + ridertag"
                        >
                        {{ridertag}}<span v-if="idx != bookObj.ridertags.length - 1">,</span>
                    </a>
                    
                </span>

                <div style="margin-top:15px">
                    <b-tag v-if="bookObj.touring" class="tag is-light" >touring</b-tag>
                    <b-tag v-if="bookObj.bikepacking" class="tag is-light" >bikepacking</b-tag>
                    <b-tag v-if="bookObj.racing" class="tag is-light" >racing</b-tag>

                    <span v-if="bookObj.audible" >
                        <b-tag v-if="bookObj.audible" class="tag is-primary">Audible</b-tag>
                      
                    </span>

                </div>

            </div>

            <div v-if="!isMinimal" class="card-footer">
                <a class=" card-footer-item" :href="bookObj.amazon_url + '?tag=bikesleepbike-20'" target="_blank" rel="nofollow" style="font-weight:bold">View on Amazon
                    <!-- <b-icon pack="fas" icon="external-link-alt" type="is-primary" size="is-small" style="margin-left:5px"></b-icon> -->
                   
                </a>
            </div>





              
          </div>
      </div>
    
        <!-- <p>{{bookObj}}</p> -->
            
      <!-- </div> -->
  
  </div>
</template>

<script>
export default {
  name: 'Book',
  props: {
      isMinimal: {
          type: Boolean
      },
      bookObj: Object,
      showBook: {
          type: Boolean,
          default: true
        },
        filterable: {
            type: Boolean
        }
    },
  data () {
    return {
    //   showBookForReal: props[showBook] != undefined &&
    }
  },
  methods: {
    
  },
  mounted() {
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .book-cover {
      height:100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Book.vue